import { Palette } from '$setup/material-theme'

type NativeColor = string | 'default'

export function setNativeThemeColorImmediately(color: NativeColor) {
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute('content', color === 'default' ? Palette.neutral100 : color)
}

export function setBottomSafeAreaColorImmediately(color: NativeColor) {
  document.documentElement?.style.setProperty(
    '--safe-area-color',
    color === 'default' ? 'var(--safe-area-color__default)' : color,
  )
}
